import lang from '@/lang/middleware/products/banking/current-accounts';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const subtitle = store.$i18n.t('index.jumbotron.subtitle');
  const title = store.$i18n.t('index.jumbotron.title');
  const description = store.$i18n.t('index.description');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'expanded' });
  store.commit('pageContent/setHead', { title, description });
};
